export default "__VITE_ASSET__2FkZiLOh__"